"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTileJson = void 0;
const isObject_1 = require("./isObject");
const isTileJson = (value) => {
    return (0, isObject_1.isObject)(value) && typeof value.character === 'string' && typeof value.isBlank === 'boolean';
};
exports.isTileJson = isTileJson;
